<template>
    <svg :width="width" :height="height" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.9 4.00504H20V8.00904C20 8.55504 19.55 9.00504 19 9.00504C18.45 9.00504 18 8.55504 18 8.00904V6.00504H16V8.00504C16 8.55504 15.55 9.00504 15 9.00504C14.45 9.00504 14 8.55504 14 8.00504V6.00504H9.9C9.64908 7.21639 8.95818 8.29178 7.96074 9.02353C6.9633 9.75527 5.73009 10.0914 4.49929 9.96712C3.26848 9.8428 2.12741 9.2668 1.29645 8.35037C0.465497 7.43394 0.00361069 6.2421 2.52787e-06 5.00504C-0.00124362 3.76508 0.458283 2.5689 1.28938 1.6487C2.12047 0.728503 3.26383 0.149939 4.49751 0.0253254C5.73118 -0.0992882 6.96715 0.23894 7.96548 0.97435C8.9638 1.70976 9.65326 2.78988 9.9 4.00504V4.00504ZM5 8.00504C5.79565 8.00504 6.55871 7.68897 7.12132 7.12636C7.68393 6.56375 8 5.80069 8 5.00504C8 4.20939 7.68393 3.44632 7.12132 2.88372C6.55871 2.32111 5.79565 2.00504 5 2.00504C4.20435 2.00504 3.44129 2.32111 2.87868 2.88372C2.31607 3.44632 2 4.20939 2 5.00504C2 5.80069 2.31607 6.56375 2.87868 7.12636C3.44129 7.68897 4.20435 8.00504 5 8.00504V8.00504Z"
            :fill="color"
            class="icon"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconKey',
    props: {
        color: {
            type: String,
            default: '#6E6E6E',
        },
        width: {
            type: Number,
            default: 32,
        },
        height: {
            type: Number,
            default: 18,
        },
    },
}
</script>

<style lang="sass" scoped>
.icon
    transition: 0.5s ease all
</style>
